import React, { useState } from "react";
import { useTripContext } from "./TripContext";
import TripDetailsActions from "./TripDetailsActions";
import TripDetailsInfo from "./TripDetailsInfo";
import PhotoDetails from "./TripDetailsPhoto";
import TripVariantsSection from "./TripVariantsSection";
import { useToast } from "../../Contexts/ToastContext";
import useApi from "../CustomHooks/useApi";
import { tripAPI } from "../../api/apiClient";
import ConfirmWithPhrasePopup from "../Common/ConfirmWithPhrasePopup";

const TripDetailsContent = ({ onEditClick, onVariantClick, onRegistrationsClick, onAttendanceClick, onAccessClick, onInsuranceClick, onDiscordClick, onPriorityClick, onSummaryClick, tripGuid }) => {
  const { updateTripStatus, tripData, fetchTripData, hasExplicitAccess } = useTripContext();
  const { showToast, clearToast } = useToast();
  const { callApi: changeStatus, isLoading: isChangingStatus } = useApi();
  const { callApi: changeSettlementStatus, isLoading: isChangingSettlement } = useApi();

  const [showConfirmReady, setShowConfirmReady] = useState(false);
  const [showConfirmArchive, setShowConfirmArchive] = useState(false);

  const handleStatusChange = async (newStatus, onSuccess) => {
    showToast("Zmiana statusu...", "processing");
    await changeStatus(
      () => tripAPI.changeTripStatus(tripGuid, newStatus),
      (newStatus) => {
        updateTripStatus(newStatus);
        onSuccess();
        showToast("Status wycieczki został zaktualizowany!", "success");
      },
      clearToast
    );
  };

  const handleSettlementChange = async (newStatus) => {
    showToast("Aktualizacja statusu rozliczenia...", "processing");
    await changeSettlementStatus(
      async () => tripAPI.changeSettlementStatus(tripGuid, newStatus),
      async () => {
        await fetchTripData();
        showToast("Status rozliczenia został zaktualizowany", "success");
      },
      clearToast
    );
  };

  if (!tripData) return <div>Brak danych wycieczki.</div>;

  return (
    <>
      <TripDetailsActions
        onEditClick={onEditClick}
        onRegistrationsClick={onRegistrationsClick}
        onAttendanceClick={onAttendanceClick}
        onAccessClick={onAccessClick}
        onInsuranceClick={onInsuranceClick}
        onPriorityClick={onPriorityClick}
        tripGuid={tripGuid}
        onDiscordClick={onDiscordClick}
        isMentor={tripData.isCurrentUserMentor}
        onMarkReadyForSettlement={() => setShowConfirmReady(true)}
        onArchiveSettlement={() => setShowConfirmArchive(true)}
        onSummaryClick={onSummaryClick}
        tripSettlementStatus={tripData.tripSettlementStatus}
        isUpdatingSettlement={isChangingSettlement}
        hasExplicitAccess={hasExplicitAccess}
      />

      <PhotoDetails photoUrl={tripData.photoLink} />

      <TripDetailsInfo
        status={tripData.status}
        isInternalTrip={tripData.isInternalTrip}
        isCurrentUserMentor={tripData.isCurrentUserMentor}
        onConfirmStatusChange={handleStatusChange}
        isLoading={isChangingStatus}
        tripSettlementStatus={tripData.tripSettlementStatus}
        takenForSettlementByUser={tripData.takenForSettlementByUser}
      />

      <TripVariantsSection variants={tripData.variants} onVariantClick={onVariantClick} />

      {showConfirmReady && (
        <ConfirmWithPhrasePopup
          phrase="rozlicz"
          text="Czy na pewno chcesz zgłosić wycieczkę do rozliczenia?"
          onConfirm={() => {
            setShowConfirmReady(false);
            handleSettlementChange(2);
          }}
          onCancel={() => setShowConfirmReady(false)}
        />
      )}
    </>
  );
};

export default TripDetailsContent;
